import BaseInput from './BaseInput.vue';

export default BaseInput;

export { BaseInput };
